export const extractPrimaryImage = (product) => {
  const fallback = { url: null, thumbnailUrl: null, name: null };

  if (!product) {
    return fallback;
  }

  if (product.primaryImageUrl || product.primaryThumbnailUrl) {
    return {
      url: product.primaryImageUrl || product.primaryThumbnailUrl,
      thumbnailUrl: product.primaryThumbnailUrl || product.primaryImageUrl || null,
      name: product.primaryImageName || null
    };
  }

  const images = Array.isArray(product.images) ? product.images : [];
  if (!images.length) {
    return fallback;
  }

  const first = images.find(Boolean);
  if (!first) {
    return fallback;
  }

  if (typeof first === 'string') {
    return {
      url: first,
      thumbnailUrl: first,
      name: first.split('/').pop() || null
    };
  }

  return {
    url: first.url || first.path || null,
    thumbnailUrl: first.thumbnailUrl || first.thumb || first.url || first.path || null,
    name: first.name || (first.url ? first.url.split('/').pop() : null)
  };
};

export const extractGalleryImages = (product) => {
  if (!product || !Array.isArray(product.images)) {
    return [];
  }

  return product.images
    .map((item) => {
      if (!item) return null;
      if (typeof item === 'string') {
        return {
          url: item,
          thumbnailUrl: item,
          name: item.split('/').pop() || null
        };
      }
      return {
        url: item.url || item.path || null,
        thumbnailUrl: item.thumbnailUrl || item.thumb || item.url || item.path || null,
        name: item.name || (item.url ? item.url.split('/').pop() : null)
      };
    })
    .filter(Boolean);
};
